import React, { useState, useContext } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { AppContext, SET_OCCASIONFILTER } from "../Context";
import { getFilterData } from "./util";

import CardSection from "../Common/cardSection";
import { STATE_CULTURE } from "../Actions/stateActions";
import { CloseButton } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  weekViewFilter: {
    height: theme.height,
  },
  header: {
    // height: "50px",
    display: "flex",
    alignItems: "center",
    padding: "0 16px",
    borderBottom: `1px solid ${theme.app.borderColor}`,
  },
  heading: {
    fontSize: "1.25rem",
    padding: "0 .7rem",
    marginTop: "0.45rem"
  },
  button: {
    color: theme.app.labelColor,
    borderRadius: "50%",
    cursor: "pointer",
    padding: "4px",
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    "&:hover": {
      backgroundColor: theme.app.hoverBackground[1],
    },
  },
  content: {
    // height: "calc(100% - 50px)",
    overflow: "auto",
    background: theme.app.background[0],
  },
  checkbox: {
    padding: "6px",
  },
  labelText: {
    fontSize: "0.875rem",
    color: theme.app.labelColor,
  },
}));

const Filter = (props) => {
  const { close, week } = props;
  const classes = useStyles();
  const [activePanel, setActivePanel] = useState("activities");
  const { language, culture } = useSelector((state) => ({
    language: state.language,
    culture: state.cookies[STATE_CULTURE],
  }));
  const context = useContext(AppContext);
  const { state, dispatch } = context;
  const setFilter = (type, value, checked) =>
    dispatch({ type: SET_OCCASIONFILTER, payload: { type, value, checked } });
  const { occasionFilter } = state;
  const togglePanel = (panel) => {
    if (panel === activePanel) {
      return setActivePanel("");
    }
    return setActivePanel(panel);
  };

  if (!week) {
    return null;
  }

  const locale = culture.substring(0, 2).toLowerCase();
  const { locations, activities, weekdays, tags } = getFilterData(week, locale);

  return (
    <main className={classes.weekViewFilter}>
      <div className={classes.header}>
        <CloseButton
          className={classes.button}
          onClick={close}
          aria-label={language.closeMenus}
        />
      <h1 className={classes.heading}>{language.filter}</h1>

      </div>
      <div className={classes.content}>
        {locations.length > 0 && (
          <CardSection
            heading={language.locations}
            expanded={activePanel === "locations"}
            toggleExpanded={() => togglePanel("locations")}
          >
            {locations.map((locationName, i) => (
              <div key={i}>
                <FormControlLabel
                  classes={{ label: classes.labelText }}
                  control={
                    <Checkbox
                      checked={occasionFilter.locations.includes(locationName)}
                      onChange={(e) =>
                        setFilter("locations", e.target.value, e.target.checked)
                      }
                      value={locationName}
                    />
                  }
                  label={locationName}
                />
              </div>
            ))}
          </CardSection>
        )}

        {activities.length > 0 && (
          <CardSection
            heading={language.activities}
            expanded={activePanel === "activities"}
            toggleExpanded={() => togglePanel("activities")}
          >
            {activities.map((activityName, i) => (
              <div key={i}>
                <FormControlLabel
                  classes={{ label: classes.labelText }}
                  control={
                    <Checkbox
                      checked={occasionFilter.activities.includes(activityName)}
                      onChange={(e) =>
                        setFilter(
                          "activities",
                          e.target.value,
                          e.target.checked
                        )
                      }
                      className={classes.checkbox}
                      value={activityName}
                    />
                  }
                  label={activityName}
                />
              </div>
            ))}
          </CardSection>
        )}

        {weekdays.length > 0 && (
          <CardSection
            heading={language.weekdays}
            expanded={activePanel === "weekdays"}
            toggleExpanded={() => togglePanel("weekdays")}
          >
            {weekdays.map((weekDay, i) => (
              <div key={i}>
                <FormControlLabel
                  classes={{ label: classes.labelText }}
                  control={
                    <Checkbox
                      checked={occasionFilter.weekdays.includes(weekDay)}
                      onChange={(e) =>
                        setFilter("weekdays", e.target.value, e.target.checked)
                      }
                      className={classes.checkbox}
                      value={weekDay}
                    />
                  }
                  label={weekDay}
                />
              </div>
            ))}
          </CardSection>
        )}

        {tags.length > 0 && (
          <CardSection
            heading={language.tags}
            expanded={activePanel === "tags"}
            toggleExpanded={() => togglePanel("tags")}
          >
            {tags.map((t, i) => (
              <div key={i}>
                <FormControlLabel
                  classes={{ label: classes.labelText }}
                  control={
                    <Checkbox
                      checked={occasionFilter.tags.includes(t)}
                      onChange={(e) =>
                        setFilter("tags", e.target.value, e.target.checked)
                      }
                      className={classes.checkbox}
                      value={t}
                    />
                  }
                  label={t}
                />
              </div>
            ))}
          </CardSection>
        )}
      </div>
    </main>
  );
};

export default Filter;
